import { useCallback } from 'react';
import { useCommonClient } from '@/app/common/commonClientProvider';
import { useInitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';
import getSearchParams from '@/app/components/search/common/getSearchParams';
import { URLParameters } from '@/app/common/urlParameters';
import type { PriceCalendarInteractionAction } from '@/app/common/starTrack/events/priceCalendarInteraction.ts';
import { createPriceCalendarInteractionPayload } from '@/app/common/starTrack/events/priceCalendarInteraction.ts';

/**
 * Fires PRICE_CALENDAR_INTERACTION for the Apex price calendar: month navigation (dropdown, arrows)
 * and day selection. The searchId is read from the live URL at call time because the calendar keeps
 * running across the client-side navigations a day click triggers, so a value captured at mount would
 * describe the previous search.
 */
export function useTrackPriceCalendarInteraction() {
  const { starTrack } = useCommonClient();
  const { productDetailKey } = useInitialParams();

  return useCallback(
    (action: PriceCalendarInteractionAction) => {
      starTrack.priceCalendarInteraction(
        createPriceCalendarInteractionPayload({
          searchId: getSearchParams()[URLParameters.SEARCH_ID] || '',
          productDetailKey,
          action,
        })
      );
    },
    [starTrack, productDetailKey]
  );
}
